/**
 * 車両グループ用のスクリプト
 */
 if (is_route('group_vehicle.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        group_vehicle_event_set();
    });
}


/**
 * ページ読み込み時のイベント設定
 */
window.group_vehicle_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true, function(){
            group_vehicle_setting_event_set();
        });
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id'], true);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });
}
/**
 * 設定時のイベント設定
 */
window.group_vehicle_setting_event_set = function()
{
    /**
     * 車両選択制御
     */
    var vehicle_choice = {
        // 候補車両クリア
        clearBefore: function() {
            $('select.before-join').empty();
        },
        // 車両リセット
        clearAfter: function() {
            let after = $('select.after-join');
            let vehiclesHidden = $('#vehiclesHidden');
            let base = after.data('base');
            let options = '';
            let hidden = '';

            after.empty();
            vehiclesHidden.empty();

            // 元の状態選択の時は、元に戻す
            if (base.length > 0) {
                $.each(base, function(idx, option) {
                    options += '<option value=' + option.id + '>' + option.text + '</option>';
                    hidden += '<input type="hidden" name="vehicle_id[]" value="' + option.id + '" id="vehicles_' + option.id + '" />';
                });
                after.append(options);
                vehiclesHidden.append(hidden);
            }

        },
        // 車両候補セット
        setBefore: function(section_id) {
            let select = $('select.before-join');
            let action = $(select).data('action');
            let after = $('select.after-join');
            let base = after.data('base');

            let data = {
                'section_id': section_id,
                'exclude': base.length > 0 ? base.map((obj) => obj.id) : [],
                'onPrepend': 0,
            }
            _ajax.post(action, data, function (results) {
                vehicle_choice.clearBefore();
                let options = '';
                $.each(results.options, function(idx, option) {
                    options += '<option value=' + option.id + '>' + option.text + '</option>';
                });

                select.append(options);
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        },
        // 追加押下
        setJoin: function(all = false) {
            let selectElements = all ? $('select.before-join').find('option:not(.d-none)') : $('select.before-join').find('option:selected');
            let options = '';
            let hidden = '';
            selectElements.each(function(){
                options += '<option value=' + $(this).val() + '>' + $(this).text() + '</option>';
                hidden += '<input type="hidden" name="vehicle_id[]" value="' + $(this).val() + '" id="vehicle_id_' + $(this).val() + '" />';
                $(this).remove();
            });
            $('select.after-join').append(options);
            $('#vehiclesHidden').append(hidden);
        },
        // 削除押下
        setNotJoin: function(all = false) {
            let selectElements = all ? $('select.after-join').find('option:not(.d-none)') : $('select.after-join').find('option:selected');
            let options = '';
            selectElements.each(function(){
                options += '<option value=' + $(this).val() + '>' + $(this).text() + '</option>';
                $('#vehicle_id_' + $(this).val()).remove();
                $(this).remove();
            });
            $('select.before-join').append(options);
        }
    }

    let section_id = $('#group_vehicle-setting-modal-section_id');
    if (section_id.length > 0 && section_id.val() !== '') {
        vehicle_choice.setBefore(section_id.val());
    }

    /*---- 営業所切替による車両選択出し分け ----*/

    $(document).off('change', '#group_vehicle-setting-modal-form select.section-select');
    $(document).on('change', '#group_vehicle-setting-modal-form select.section-select', function () {
        // 車両クリア
        vehicle_choice.clearAfter();
        // 候補車両クリア
        vehicle_choice.clearBefore();
        if ($(this).find('option:selected').length > 0
            && $(this).find('option:selected').val() !== '') {
            // 候補車両取得
            vehicle_choice.setBefore($(this).val());
        }
    });

    /*---- 車両追加 ----*/

    $(document).off('click', 'button#add');
    $(document).on('click', 'button#add', function () {
        vehicle_choice.setJoin();
    });

    $(document).off('click', 'button#add_all');
    $(document).on('click', 'button#add_all', function () {
        vehicle_choice.setJoin(true);
    });

    /*---- 車両削除 ----*/

    $(document).off('click', 'button#remove');
    $(document).on('click', 'button#remove', function () {
        vehicle_choice.setNotJoin();
    });

    $(document).off('click', 'button#remove_all');
    $(document).on('click', 'button#remove_all', function () {
        vehicle_choice.setNotJoin(true);
    });

}
